import React from 'react'
import classNames from 'classnames'

import { LntIconButton } from '@app/components/base'

import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { DraggableButtonProps } from './types'

export const DraggableButton: React.FC<DraggableButtonProps> = ({
  className: outerClassName,
  disabled,
  attributes,
  listeners,
  setActivatorNodeRef,
  ...restProps
}) => {
  const className = classNames(styles.draggableButton, outerClassName)

  const draggableProps = !disabled && {
    ...attributes,
    ...listeners
  }

  return (
    <LntIconButton
      { ...restProps }
      { ...draggableProps }
      className={ className }
      disabled={ disabled }
      size={ SIZE.small }
      type={ BUTTON_TYPE.text }
      icon={ <Icon name={ ICON_NAME.draggable } /> }
      ref={ setActivatorNodeRef }
    />
  )
}
